import MyAssignmentsRoot from './components/MyAssignmentsRoot.vue'

export default [
  {
    path: 'my-assignments',
    component: MyAssignmentsRoot
  }
]
